import React, { useEffect, useRef, useState } from "react";
import { NavDropdown } from "react-bootstrap";
import Translator from "../helper/Translate";
import { changeLanguagePreferenceAction, selectLanguageAction } from "../redux/language/language.actions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

const LanguageDropdown = () => {

  const [language, setLanguage] = useState([
    {
      logo: "/images/Italian.svg",
      code: "it",
      name: "Italian"
    },
    {
      logo: "/images/English.svg",
      code: "en",
      name: "English"
    }
  ]);
  // const [selectedLanguage, setSelectedLanguage] = useState({});
  const langRef = useRef();
  const dispatch = useDispatch();

  const selectedLanguage = useSelector(state => state.languageInfo.selectedLanguage);

  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      if (!language.map(elem => elem.name).includes(storedLanguage)) {
        // setSelectedLanguage(language[0]);
        dispatch(selectLanguageAction(language[0]));
        localStorage.setItem("language", language[0].name);
      } else {
        const updatedData = language.filter(elem => elem.name === storedLanguage)[0]
        // setSelectedLanguage(language.filter(elem => elem.name === storedLanguage)[0]);
        dispatch(selectLanguageAction(updatedData));
      }
    } else {
      // setSelectedLanguage(language[0]);
      dispatch(selectLanguageAction(language[0]));
      localStorage.setItem("language", language[0].name);
    }
  }, []);

  const onSelectLanguage = (selectedLanguageEvent) => {
    // setSelectedLanguage(selectedLanguageEvent);
    dispatch(changeLanguagePreferenceAction(selectedLanguageEvent));

    if (selectedLanguageEvent.code === "it") {
      langRef.current({ target: { value: selectedLanguageEvent.code } });
      window.location.reload();
    } else {
      langRef.current({ target: { value: selectedLanguageEvent.code } });
    }
  };

  return (
    <>
      <Translator langRef={langRef} />
      {
        selectedLanguage && Object.keys(selectedLanguage).length > 0 &&
        <li className="nav-item dropdown">
          <NavDropdown
            title={
              <span>
                <img
                  src={`${process.env.PUBLIC_URL}${selectedLanguage.logo}`}
                  alt={selectedLanguage.name}
                  style={{ width: "20px", height: "20px", marginRight: "5px" }}
                />
              </span>
            }
            id="navbarDropdown"
          >
            {
              language.map(elem => (
                <NavDropdown.Item key={elem.name} onClick={e => {
                  onSelectLanguage(elem);
                }}>
                  <img
                    src={`${process.env.PUBLIC_URL}${elem.logo}`}
                    alt="Italian"
                    style={{ width: "20px", height: "20px", marginRight: "5px" }}
                  />
                  {elem.name}
                </NavDropdown.Item>
              ))
            }
          </NavDropdown>
        </li>
      }
    </>
  );
}

export default LanguageDropdown;